<template>
    <Spin fix v-if="options.showToast">
        <div class="spin-box" :style="'background-color: rgba(246, 247, 249,' + options.opacity + ')'">
            <img class="bg" :src="options.imgSrc" alt="">
            <div class="bar-box">
                <div class="bar">
                    <div class="bar-item" :style="'width:'+ options.progress + '%'"></div>
                </div>
                <div class="tips">Large Language Model-Driven 3D Avatar Present and chat with Your PowerPoint/Slides.</div>
            </div>
        </div>
    </Spin>
</template>

<script setup>
import { Spin, Icon, Progress } from "view-ui-plus";
import { ref, watch, getCurrentInstance } from "vue";
const opt = defineProps({
    options: {
        type: Object,
        default: {},
    },
});

watch(
    () => opt.options.progress,
    (newValue, oldValue) => {
        console.log(newValue);
    }
);
</script>

<style lang="less">
.ivu-spin-fix {
    z-index: 99999 !important;
    background-color: transparent !important;
}
.ivu-progress-inner {
    background: #fff !important;
}
.ivu-progress-inner-text {
    height: 8px !important;
    line-height: 0;
}
</style>
<style lang="less" scoped>


.spin-box {
    height: 100vh;
    width: 100vw;
    position: relative;
    overflow: hidden;
    .bg {
        position: absolute;
        width: 100%;
        left: 50%;
        top: 0%;
        transform: translateX(-50%);
        height: auto;
    }
    .bar-box {
        position: absolute;
        bottom: 0;
        background: url('@/assets/bar-shadow.png') no-repeat center center;
        background-size: cover;
        width: 100%;
        height: 150px;
        padding: 80px 27px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .bar {
            width: 100%;
            height: 12Px;
            background: #fff;
            border-radius: 8Px;
            position: relative;
            // overflow: hidden;
            .bar-item {
                position: absolute;
                left: 0px;
                top: 0;
                border-radius: 8Px;
                height: 100%;
                width: 0%;
                background: #4945FFFF;
                &::after {
                    position: absolute;
                    content: '';
                    background: url('@/assets/loading.gif') no-repeat;
                    background-size: cover;
                    right: -46px;
                    top: -70px;
                    width: 80px;
                    height: 60px;
                    z-index: 1;
                }
                &::before {
                    position: absolute;
                    content: '';
                    background: url('@/assets/bar-icon.png') no-repeat;
                    background-size: cover;
                    right: -32px;
                    top: -72px;
                    width: 62px;
                    height: 68px;

                }
            }
        }

        .tips {
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            text-align: center;
            margin-top: 10px;
        }
    }
}

</style>
